import{ useEffect, useState } from "react";
import baseURL from "../../authComponents/baseURL/BaseURL";
import loginToken from "../../authComponents/localStorageItems/LoginTokin";
import { Link, useNavigate } from "react-router-dom";

const EditAnnouncementForm = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
    const navigate =useNavigate()

  // Fetch announcement content
  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const response = await baseURL.get("/admin/announcement", {
          headers: {
            Authorization: `Bearer ${loginToken}`,
          },
        });
        const data = response.data?.announcement;
        setContent(data?.content || "");
      } catch (err) {
        console.error("Error fetching announcement:", err);
        setError("Failed to load announcement.");
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncement();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    try {
      await baseURL.post(
        "/admin/announcement/update_announcement",
        { content },
        {
          headers: {
            Authorization: `Bearer ${loginToken}`,
          },
        }
      );
      setSuccess("Announcement updated successfully.");
    } catch (err) {
      if (err.response.status == 422) {
        setError(err?.response?.data?.errors[0])
      } else {
        console.error("Error updating announcement:", err);
      }
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
       <div className="bg-gradient-to-r from-[#730000] to-red-700 text-white p-6">
            <h2 className="text-4xl font-bold mb-2">Edit Announcement</h2>
            <p className="text-red-100">Manage your Announcement to keep your Users Updated</p>
          </div>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4"></h2>

      {loading ? (
        <p className="text-gray-600">Loading...</p>
      ) : (
        <form className=" mx-auto bg-white shadow-md rounded p-6 mt-10 font-serif" onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="announcement"
              className="block text-gray-700 font-medium mb-2"
            >
              Announcement Content
            </label>
            <textarea
              id="announcement"
              className="w-full h-40 p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              required
            />
          </div>
          <div className="flex gap-2">

          <button
            type="submit"
            className="px-6 py-3 bg-gradient-to-r from-[#730000] to-red-700 text-white rounded-lg hover:from-red-800 hover:to-red-800 transition-all duration-200 font-medium shadow-lg"
          >
            Update Announcement
          </button>
          <button
            type="button"
            onClick={()=>navigate(-1)}
            // className=" text-white bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-pink-300 dark:focus:ring-pink-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
          >
            Cancel
          </button>
          </div>

          {success && (
            <p className="mt-4 text-green-600 font-medium">{success}</p>
          )}
          {error && (
            <p className="mt-4 text-red-600 font-medium">{error}</p>
          )}
        </form>
      )}

        </div>
        </div>
    </div>
  );
};

export default EditAnnouncementForm;
